const translations = {
  "en": {
    "Click to view": "Click to view"
  },
  "zh-tw": {
    "Click to view": "點選查看"
  }
};

export default translations;
